import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React from "react";
import debounce from "lodash.debounce";
/**
 * Creates a function that allows to debounce any callback
 *
 * @example
 * const debounceCallback = useCallbackDebouncer(1000);
 *
 * functon handleChange() {
 *   debounceCallback(() => onChange(1))
 *   debounceCallback(() => onChange(2))
 *   debounceCallback(() => onChange(3)) // Only onChange(3) will be called
 * }
 *
 * @param {number} debounceDelay milliseconds
 * @param {Object} options https://lodash.com/docs/4.17.15#debounce
 * @returns {callbackFn(callbackFn => any)}
 */

export default function useCallbackDebouncer() {
  var debounceDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _React$useState = React.useState(function () {
    return debounce(function (callbackFn) {
      return callbackFn();
    }, debounceDelay, options);
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      debounceCallback = _React$useState2[0];

  return debounceCallback;
}
//# sourceMappingURL=useCallbackDebouncer.js.map